




import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'


import LocalStorageService from '../../../services/LocalStorageService'
import NotificationService from '../../../services/NotificationService'
import UserService from '../../../services/UserService'
import OrganisationTagService from '../../../services/OrganisationTagService'

import OrganisationService from '../../../services/OrganisationService'



// Appt Components
import Box from '../../../components/simple/box/Box'
import Divider from '../../../components/simple/divider/Divider'
import Form from '../../../components/simple/form/Form'
import FormField from '../../../components/simple/formField/FormField'
import TextInput from '../../../components/simple/input/TextInput'
import ActionButton from '../../../components/compound/actionButton/ActionButton.js'
import PulseLoader from 'react-spinners/PulseLoader.js'
import RoleService from '../../../services/RoleService.js'
import PasswordService from '../../../services/PasswordService.js'

function Details (props) {
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)

    const apiToken = LocalStorageService.get('apiToken')
    const activeOrg = LocalStorageService.get('activeOrg')
    const terms = LocalStorageService.get('terms')



      // Initialize userDetails otherwise we get error
      // A component is changing an uncontrolled input of type text to be controlled
      const [userDetails, setUserDetails] = useState({
        organisation: 0,
        role: 0,
        // username: '',
        firstName: '',
        lastName: '',
        email: '',
        jobTitle: ''
      })

      // Contains array of org objects for populating the School dropdown
      const [orgValues, setOrgValues] = useState([])

      const [saveLocked, setSaveLocked] = useState(false)


      // Contains an Organisation object that has been selected from the School dropdown
      const [selectedOrg, setSelectedOrg] = useState(null)

      // Contains array of role objects for populating the Role dropdown
      const [roleValues, setRoleValues] = useState([])

      const [originalRole, setOriginalRole] = useState(null)

      const [safeguardingLeads, setSafeguardingLeads] = useState([])


    const params = useParams()
    const userId = params.userid



    // Submit form values
    const submitForm = async (values) => {
      if (userId === 'new') {

        setSaveLocked(true)

        var userAdded = await UserService.inviteUser(apiToken, values)
        if (userAdded?.error) {
          // If the error message is about a user limit, display it
          var errorStr = 'Error saving the user, please try again.'
          if (userAdded?.error?.errorType === 'userlimit') {
            errorStr = userAdded.error.error
          }
          NotificationService.error(errorStr)
        } else {
          NotificationService.info('User added')
          navigate('/users', { message: userAdded.data.message })
        }
      } else {
        var userUpdated = await UserService.updateUser(apiToken, values)
        if (userUpdated?.error) {
          NotificationService.error('Error saving the user, please try again - ', userUpdated?.error)
          return
        }

        // if the role has changed, update the role
        if (values.role && originalRole !== values.role) {
          var roleUpdated = await RoleService.addRoleUser(apiToken, null, values.role, values.id)
          if (roleUpdated?.error) {
            NotificationService.error('Error saving the user, please try again - ', roleUpdated?.error)
            return
          }
        }

        NotificationService.success('User updated successfully')
        navigate('/users', { message: 'User updated successfully' })

      }
    }

    // Reset User password
    const resetPassword = async (email) => {
      try {
        var passwordResetStatus = await PasswordService.resetPasswordRequest(null, email)
      } catch (err) {
        NotificationService.error('Password reset error - ', err)
        return
      }

      NotificationService.success('Password reset email has been sent', passwordResetStatus)
    }

    const deleteUser = () => {
      navigate('userdelete')
    }

    // Go Back
    const goBack = () => {
      navigate(-1)
    }

    useEffect(() => {
      // get the current user's role
      const getRoleForUser = async () => {
        // don't do anything if the user is new
        if (userId === 'new') {
          return
        }

        // don't do anything if we don't have any roles
        if (!roleValues.length) {
          return
        }

        // don't do anything if we don't have a selectedOrg
        if (!selectedOrg.id) {
          return
        }

        const roles = await RoleService.getRoleForUser(apiToken, userId)
        if (roles?.error) {
          NotificationService.error(roles.error)
        } else if (roles?.data) {
          // get the role that belongs to the current organisation
          var roleForThisOrg = roles.data.find(role => parseInt(role.organisation) === selectedOrg.id)
          if (roleForThisOrg) {
            setUserDetails({
              ...userDetails,
              role: roleForThisOrg.id
            })

            setOriginalRole(roleForThisOrg.id)

          }
        }
      }

      if (selectedOrg) {
        getRoleForUser()
      }
    }, [roleValues, selectedOrg])

    useEffect(() => {
      const getRoles = async () => {
        // don't do anything if we don't have a selected org
        if (!selectedOrg?.id) {
          return
        }
        const roles = await OrganisationService.getRolesForOrg(apiToken, selectedOrg.id)
        if (roles?.error) {
          NotificationService.error(roles.error)
        } else if (roles?.data) {

          for (let role of roles.data) {
            if ( role.name === 'Admin') {
              role.name = 'Full User'
            } else if (role.name === 'Standard') {
              role.name = 'Restricted User'
            }
          }
          setRoleValues(roles.data)
        }
      }

      if (selectedOrg) {
        getRoles()
      }
    }, [selectedOrg])

    useEffect(() => {
      let unmounted = false
      const getUserDetails = async (userId) => {
        const params = {
          fields: 'id,firstName,lastName,email,jobTitle',
          type: 'user'
        }

        const response = await UserService.getUser(apiToken, params, userId)
        if (response?.error) {
          NotificationService.error(response.error)
        } else {
          var newDetails = {
            ...userDetails,
            ...response.data[0]
          }
          setUserDetails(newDetails)
        }
      }
      if (!unmounted) {
        if (userId !== 'new') {
          getUserDetails(userId)
        }
      }
      return () => { unmounted = true }
    }, [orgValues])

    useEffect(() => {
      let unmounted = false

      const getOrganisations = async () => {
        var organisations = LocalStorageService.get('userOrganisations')
        if (organisations?.error) {
          NotificationService.error(organisations.error)
        } else {
          setOrgValues(organisations)
          setSelectedOrg(activeOrg)

          // make sure the organisations comes back as an array
          var toSave = {
            ...userDetails,
            organisation: activeOrg.id
          }
          setUserDetails(toSave)
        }
      }
      if (!unmounted) {
        getOrganisations()
      }
      return () => { unmounted = true }
    }, [])

    const getSafeguardingLeads = async () => {

      const params = {
        fields: 'type,key,value',
        limit: 100,
        orgId: activeOrg.id
      }

      const where = {
        type: 'besmart'
      }

      const organisationTags = await OrganisationTagService.get(apiToken, params, where)
      if (organisationTags) {
        organisationTags.forEach(tag => {
          if (tag.key === 'safeguardingLeads') {
            try {
                let sLeads = JSON.parse(tag.value)
                setSafeguardingLeads(sLeads)
              } catch (err) {
                console.error(err)
              }
          }
        })
      }

    }

    useEffect(() => {
      getSafeguardingLeads()
    }, [])


  if (loading) {
    return <Box direction='row' gap='medium' >
      <Box background='white' direction='column' gap='small' margin={{ top: 'small', bottom: 'large' }} border={{ color: 'light-4', side: 'right' }} pad='medium' flex='grow'>
        <PulseLoader color='#ff8300' size={15} margin={5} />
      </Box>
    </Box>
  }

  return (
    <Box direction='row' gap='medium' margin={{ top: 'small', bottom: 'larmediumge' }}>
    <Box background='white' direction='column' gap='small'  border={{ color: '#eee', side: 'right' }} pad='small' flex='grow'>

      <Box
        gap='small'
        round='small'
      >
        <>

        <Form
          //   validate='blur'
          onChange={nextValue => {
            setUserDetails(nextValue)
          }}
          onSubmit={({ value: nextValue }) => {
                        submitForm(nextValue)
                      }}
                      value={userDetails}
                    >

                      {userId !== 'new' &&
                        <Box>

                          <Box direction='row-responsive' gap='medium'>
                            <FormField
                              label='Firstname'
                              name='firstName'
                              required
                            >
                              <TextInput
                                name='firstName'
                                type='text'
                              />
                            </FormField>

                            <FormField
                              label='Lastname'
                              name='lastName'
                              required
                            >
                              <TextInput
                                name='lastName'
                                type='text'
                              />
                            </FormField>
                          </Box>

                          <Box direction='row-responsive' gap='medium'>
                            <FormField
                              label='Email'
                              name='email'
                              required
                            >
                              <TextInput
                                name='email'
                                type='email'
                              />
                            </FormField>

                            <FormField
                              label='Job Title'
                              name='jobTitle'
                              required
                            >
                              <TextInput
                                name='jobTitle'
                                type='text'
                              />
                            </FormField>
                          </Box>
                        </Box>}




                      <Divider color='primary' margin={{ top: 'medium', bottom: 'none' }} />

                      <Box direction='row' justify='between' margin={{ top: 'medium' }}>
                        <ActionButton label='< Back' onClick={() => goBack()} secondary />
                        <ActionButton type='submit' label={(userId === 'new' ? 'Send Invite' : 'Save')} primary disabled={saveLocked} />
                      </Box>
                    </Form>
        </>
      </Box>
    </Box>

  </Box>)
}
export default Details
